module.exports = __webpack_public_path__ + "img/d.81735d53.jpg";